import * as React from 'react';
import ConsumerAssetUsage from './ConsumerAssetUsage';
import TabNavigation from '../../shared/components/TabNavigation';
import Loading from '../../shared/components/loading/Loading';
import Typography from '@material-ui/core/Typography';
import TimelineIcon from '@material-ui/icons/Timeline';
import SettingsIcon from '@material-ui/icons/Settings';
import LinkIcon from '@material-ui/icons/Link';
import BreadCrumb from '../../shared/components/BreadCrumb';
import ConsumerAssetGeneralSettings from './ConsumerAssetGeneralSettings';
import ConsumerAssetData from './ConsumerAssetData';
import NotificationsIcon from "@material-ui/icons/Notifications";
import ConsumerNotifications from './ConsumerNotifications';
import LegacyNotificationOverview from 'src/modules/organization/components/LegacyNotificationOverview';

import Asset from "../../subscription/models/Asset";
import { getAsset } from "../../shared/services/AssetApi";
import { NotificationSystem2AssetIds, DataSharingTypeEnum } from "../../shared/constants";

interface IState {
  asset: Asset | null
}

class ConsumerAssetOverview extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      asset: null
    };
  }

  public async componentDidMount() {
    const asset = await getAsset(this.props.match.params.assetid);
    this.setState({ asset });
  }

  public render() {
    if (!this.state.asset) {
      return <Loading />;
    }

    const tabs = [];
    tabs.push({
      icon: <SettingsIcon />,
      label: 'SUBSCRIPTION',
      page: {
        component: ConsumerAssetGeneralSettings,
        routeAffix: 'info',
        props: {
          assetId: this.props.match.params.assetid,
          environment: this.props.match.params.environment,
        },
      },
    });
    if (this.state.asset.dataSharing === DataSharingTypeEnum.SharingAgreements && this.props.match.params.environment === 'Live') {
      tabs.push({
        icon: <LinkIcon />,
        label: 'DATA',
        page: {
          component: ConsumerAssetData,
          routeAffix: 'data',
          props: {
            assetId: this.props.match.params.assetid,
            asset: this.state.asset,
            environment: this.props.match.params.environment,
          },
        },
      });
    }
    tabs.push({
      icon: <TimelineIcon />,
      label: 'USAGE',
      page: {
        component: ConsumerAssetUsage,
        routeAffix: 'usage',
        props: {
          assetId: this.props.match.params.assetid,
          environment: this.props.match.params.environment,
        },
      },

    });
    if (NotificationSystem2AssetIds.includes(this.props.match.params.assetid)) {
      tabs.push({
        icon: <NotificationsIcon/>,
        label: 'NOTIFICATIONS',
        page: {
          component: ConsumerNotifications,
          routeAffix: 'notifications',
        },
      });
    } else {
      tabs.push(
        {
          icon: <NotificationsIcon/>,
          label: 'NOTIFICATIONS',
          page: {
            component: () => <LegacyNotificationOverview assetView />,
            routeAffix: 'notifications'
          },
        }
      );
    }

    return (
        <div>
          <Typography variant="title">
            {this.state.asset.name} • {this.props.match.params.environment}
          </Typography>
          <Typography color="textSecondary" gutterBottom={true}>
            <BreadCrumb value="Console" to="/"/>
            <BreadCrumb value="Subscriptions" to="/subscriptions"/>
            {this.state.asset.name} • {this.props.match.params.environment}
        </Typography>
        <TabNavigation
          tabs={tabs}
          history={this.props.history}
          routeParm={this.props.match.params.tab}
        />
      </div>
    );
  }
}
export default ConsumerAssetOverview;



// WEBPACK FOOTER //
// ./src/modules/consumer/pages/ConsumerAssetOverview.tsx